import { avatarColor, initials } from "../../lib/avatar";

export function Avatar({ name, size = "md" }: { name: string; size?: "sm" | "md" | "lg" }) {
  const cls = size === "sm" ? "avatar avatar--sm" : size === "lg" ? "avatar avatar--lg" : "avatar";
  return (
    <span class={cls} style={{ background: avatarColor(name) }} aria-hidden="true">
      {initials(name)}
    </span>
  );
}
